import React from 'react';
import PropTypes from 'prop-types';

import ContentContainer from '../content-container';
import ContactLensHeader from './contact-lens-header';
import ProductList from '../product-list';
import ProductDetails from 'components/product-details';

const ContactLensPage = ({ header, productDetails, relatedProducts }) => (
  <div className="contact-lens-page">
    <ContentContainer>
      <ContactLensHeader {...header} />
      {productDetails && (
        <ProductDetails
          className="contact-lens-page__details"
          {...productDetails}
        />
      )}
      {relatedProducts && <ProductList {...relatedProducts} />}
    </ContentContainer>
  </div>
);

ContactLensPage.propTypes = {
  header: PropTypes.exact(ContactLensHeader.propTypes),
  productType: PropTypes.string,
  productDetails: PropTypes.exact(ProductDetails.propTypes),
  relatedProducts: PropTypes.exact(ProductList.propTypes)
};

export default ContactLensPage;
